// extracted by mini-css-extract-plugin
module.exports = {"switchPageBtn":"switchpageitem_switchPageBtn__3S0Hz","xs":"switchpageitem_xs__zmpjy"};